import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowsZoom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowsZoom"><Path d="M10 4.5H4.5V10" stroke="currentColor"/><Path d="M14 4.5H19.5V10" stroke="currentColor"/><Path d="M10 19.5H4.5V14" stroke="currentColor"/><Path d="M14 19.5H19.5V14" stroke="currentColor"/><Path d="M5 5L10 10" stroke="currentColor"/><Path d="M19 5L14 10" stroke="currentColor"/><Path d="M10 14L5 19" stroke="currentColor"/><Path d="M14 14L19 19" stroke="currentColor"/></CentralIconBase>;
});

export default IconArrowsZoom;
